<template>
  <VSelect
    :value="templateType"
    :items="getTemplateTypes"
    clearable
    :label="$t('forms.labels.workOrderTemplate.type')"
    :required="true"
    dense
    @input="updateData"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import templateType from '@/constants/workOrderTemplateTypes';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

export default {
    components: {
        VSelect,
    },
    props: {
        templateType: {
            type: Number,
            default: () => null,
        },
        isSite: {
            type: Boolean,
            default: () => false,
        },
        isOnService: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            teams: [templateType.PERSONAL],
        };
    },
    computed: {
        ...mapGetters([
            'hasRole',
        ]),
        getTemplateTypes() {
            return this.teams.map((element, index) => ({
                id: index,
                name: this.$t(`forms.labels.workOrderTemplate.${element}`),
            }));
        },
    },
    async mounted() {
        this.initTemplateType();
    },
    methods: {
        initTemplateType() {
            if ((this.hasRole('manager') || this.hasRole('administrator'))) {
                this.teams.push(templateType.TEAM);
            }

            if (this.isSite && !this.isOnService) {
                this.teams.push(templateType.SITE);
            }
        },
        updateData(select) {
            this.$emit('sendData', {
                type: select,
                value: this.teams[select],
            });
            if (select >= 0) {
                this.$emit('disabled', false);
            }
        },
    },
};
</script>
